import RainbowSwatch from './../RainbowSwatch'
import ColorSwatch from './../ColorSwatch'
import TextSwatch from './../TextSwatch'
import { formatCurrencyAlwaysSign } from '../../utils/money'

const OptionsPopoverItem = ({
  currencyCode,
  onClick,
  option,
  active,
  name,
  priceDiff,
  hidePrice
}) => {
  const rsw = option.custom_color ? (
    <RainbowSwatch />
  ) : option.swatch_color ? (
    <ColorSwatch hex={option.swatch_color} />
  ) : (
    <TextSwatch text={option.swatch_text} />
  )
  return (
    <div
      onClick={option.sold ? null : onClick}
      className={
        'velorbis-customizer-option ' +
        (active ? 'velorbis-customizer-option-active' : '') +
        (option.sold ? 'velorbis-customizer-hover-popover-item-sold' : '')
      }
    >
      <div className="velorbis-customizer-option-name">{name}</div>
      {option.sold ? (
        <div className="velorbis-customizer-sold-out">Sold out!</div>
      ) : (
        <div className="velorbis-customizer-option-price">
          {priceDiff == 0
            ? ''
            : hidePrice
              ? ''
              : formatCurrencyAlwaysSign(priceDiff, currencyCode)}
        </div>
      )}
      {!option.sold && rsw}
    </div>
  )
}

export default OptionsPopoverItem
